import * as React from 'react';
import { api } from './api';

export interface MenuItem {
  id: string;
  desMenu: string;
  caminho: string;
  icon?: React.ReactNode;
  disabled?: boolean;
}

export interface MenuResponse {
  success?: boolean;
  message?: string;
}

// API retorna array direto de MenuItem
export type MenuData = MenuItem[];

export const menuService = {
  // Buscar menu do usuário logado
  getMenu: async (): Promise<MenuData> => {
    const response = await api.get<MenuData>('/api/Auth/getMenus');
    return response.data;
  },

  // Converter string de icon para componente (se necessário)
  parseIcon: (iconString?: string): React.ReactNode => {
    if (!iconString) return undefined;
    
    // Se for emoji, retorna diretamente
    if (iconString.length <= 2) {
      return <span>{iconString}</span>;
    }
    
    // Se for nome de ícone do Material-UI, pode implementar mapeamento aqui
    // Por enquanto, retorna undefined para usar ícones padrão
    return undefined;
  }
};
